// extracted by mini-css-extract-plugin
module.exports = {"nav-wrapper":"SliderNavIndicator_nav-wrapper__aUZiN","slide-indicator":"SliderNavIndicator_slide-indicator__o1xur","button":"SliderNavIndicator_button__B6IjS"};